import {AddCircleOutline, AlarmOutlined, SportsScore} from "@mui/icons-material";
import {Card, Divider, Stack, Typography} from "@mui/material";
import React from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import type {MilestoneEscorts} from "../../../firebase/index.js";
import {addMilestone, auth, formatDate, Milestone} from "../../../firebase/index.js";
import {useInMemoryIndustry} from "../../../redux/InMemoryIndustryReducer.js";
import type {APXBaseOption, APXOptions} from "../../../reusables/APXMoreMenuWithPopover.jsx";
import APXMoreMenuWithPopover from "../../../reusables/APXMoreMenuWithPopover.jsx";
import {singleLineText} from "../../../reusables/js/APXCrucialStyles.js";
import {milestoneColour} from "../../../reusables/js/APXTheme.js";
import {nonPlusLimits, useInMemoryPlusStatus} from "../../../reusables/plus/APXPlus.js";
import {APXPlusRequiredAlert} from "../../../reusables/plus/APXPlusAlerts.jsx";
import AddMilestoneAchievedBSL from "./AddMilestoneAchievedBSL.jsx";
import AddNewMilestoneBSL from "./AddNewMilestoneBSL.jsx";


export default function MilestoneCard({m, l, escorts = null, placeAs = "holder"}: { m: Milestone, l: number, escorts?: MilestoneEscorts, placeAs?: "header" | "between" | "holder" }) {
	  
	  const {milestoneMillis, milestoneTitle, milestoneDetails, milestoneKey, isAchieved, achievedOn} = /*TRUTHY->*/ !!m && (m: Milestone);
	  
	  const [openNewMilestoneDialog, setOpenNewMilestoneDialog] = React.useState(false);
	  const [openMilestoneAchievedDialog, setOpenMilestoneAchievedDialog] = React.useState(false);
	  
	  const industryKey = useInMemoryIndustry()?.industryKey;
	  const uid = useAuthState(auth)[0]?.uid;
	  
	  const menuOptions: APXOptions = {
			 edit: {
					label: "Edit",
					needsConfirmation: false,
					keepDisabled: false,
					onClick: () => {
						  setOpenNewMilestoneDialog(true);
					}
			 },
			 markAsAchieved: {
					label: "Mark as Achieved",
					needsConfirmation: false,
					keepDisabled: false,
					onClick: () => {
						  setOpenMilestoneAchievedDialog(true);
					}
			 },
			 delete: {
					label: "Delete",
					needsConfirmation: true,
					keepDisabled: false,
					onClick: React.useCallback(() => {
						  addMilestone(uid, industryKey, milestoneKey, null);
					}, [uid, industryKey, milestoneKey])
			 }
	  };
	  
	  const {isPlusUser} = useInMemoryPlusStatus();
	  
	  return (
				 <>
						
						{/*FALSY->*/ !!!m ?
								  <>
										 {placeAs === "header" &&
													<Card variant={"outlined"}
															sx={{p: 2, mt: 1 /* FOR SAME EYE LEVEL AS IN THE OTHER VIEWS */, mb: 4 /* FOR EXTRA PADDING BELOW */, opacity: 0.25, borderColor: "#ffffff", borderStyle: "dashed", borderWidth: 4.5}}>
														  <Stack spacing={2} alignItems={"center"} justifyContent={"center"}>
																 <AddCircleOutline sx={{fontSize: 60}} onClick={() => setOpenNewMilestoneDialog(true)}/>
														  </Stack>
													</Card>
										 }
										 {placeAs === "between" && escorts &&
													<Card variant={"outlined"} sx={{p: 0, my: 0, opacity: 0.25, borderColor: "#00000000"}}>
														  <Stack spacing={0} alignItems={"center"} justifyContent={"center"}>
																 {escorts.prev.isAchieved && escorts.next.isAchieved ?
																			<>
																				  <VDivider height={60} colour={milestoneColour}/>
																			</>
																			:
																			<>
																				  <VDivider/>
																				  <AddCircleOutline sx={{fontSize: 48}} onClick={() => setOpenNewMilestoneDialog(true)}/>
																				  <VDivider/>
																			</>
																 }
														  </Stack>
													</Card>
										 }
								  </>
								  :
								  <Card variant={"outlined"} sx={{p: 2, my: 1, borderColor: milestoneColour}}>
										 <Stack spacing={0} alignItems={"stretch"} justifyContent={"center"}>
												<Stack direction="row" spacing={0.5} alignItems="center" justifyContent={"space-between"}>
													  <Typography variant="h4">{milestoneTitle}</Typography>
													  <APXMoreMenuWithPopover disabled={isAchieved} options={menuOptions} onConfirmedOptionSelected={(option: APXBaseOption) => option.onClick()}/>
												</Stack>
												<Typography variant="body1">{milestoneDetails}</Typography>
												<Stack direction="row" spacing={1} alignItems="center" justifyContent={"end"} color={milestoneColour}>
													  {isAchieved && achievedOn ? <SportsScore sx={{fontSize: 32}}/> : <AlarmOutlined sx={{fontSize: 32}}/>}
													  <Typography variant="h4" style={singleLineText}>
															 {formatDate(isAchieved && achievedOn ? achievedOn : milestoneMillis)}
													  </Typography>
												</Stack>
										 </Stack>
								  </Card>
						}
						{openNewMilestoneDialog ?
								  (
											 (isPlusUser)
											 ||
											 (/*NOT->*/ !isPlusUser && l < nonPlusLimits.mil.numerical)
								  ) ?
											 <AddNewMilestoneBSL m={m} e={escorts} onClose={() => setOpenNewMilestoneDialog(false)} uid={uid} industryKey={industryKey}/>
											 :
											 <APXPlusRequiredAlert/>
								  :
								  null
						}
						{openMilestoneAchievedDialog &&
								  <AddMilestoneAchievedBSL mKey={milestoneKey} onClose={() => setOpenMilestoneAchievedDialog(false)} uid={uid} industryKey={industryKey}/>
						}
				 </>
	  );
}


function VDivider({height = 24, colour = "#ffffff"}: { height?: number, colour?: string }) {
	  return <Divider flexItem={false} orientation={"vertical"} sx={{height: height, borderColor: colour, borderStyle: "dashed", borderWidth: 2.5}}/>;
}
